import { render } from "./SettingsList.vue?vue&type=template&id=320188a6&scoped=true"
import script from "./SettingsList.vue?vue&type=script&lang=js"
export * from "./SettingsList.vue?vue&type=script&lang=js"

import "./SettingsList.vue?vue&type=style&index=0&id=320188a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-320188a6"

export default script